<div class="ttmodal">
    <div class="ttmodal__header">
      <span class="ttmodal__title">{{Translate('Update Temperature Inspection')}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Inspection">close</i>
    </div>
  
  
  
    <div class="ttmodal__body">
      <div  style="width: 480px;">
        <mat-form-field class="setup-form-full-width">
          <input matInput  [min]="EquipmentSetupDate"  [max]="todate" readonly [matDatepicker]="myDatepicker" placeholder="{{'Select Inspection Date' | translate | async}}" 
          [(ngModel)]="InspectionDate" >
          <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #myDatepicker></mat-datepicker>
        </mat-form-field>
        
          <mat-form-field class="setup-form-full-width">
              <input type="number" min="0" matInput placeholder="{{'Ambient Temperature' | translate | async}}"  [(ngModel)]="AmbientTemp">
              <span matSuffix>°C</span>
            </mat-form-field>
  
  
        <div class="ttmodal__footer">
            <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
            <button mat-raised-button color="warn"    (click)="UpdateInspection()"><span class="material-icons button__icon">check</span><span
                class="button__text">{{Translate('Update Inspection')}}</span></button>
          </div>
      </div>
<!--   
      <div *ngIf="!isInspector">
        {{Translate('Please check your user permissions, Only inspector or super user can create inspections')}}
        <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
      </div> -->
  
  
  
  
  
    </div>
  
  
    
  
  </div>